module.exports = __webpack_public_path__ + "img/w21-cover.a560ec6c.jpg";